export default "__VITE_ASSET__174aff43__"